import { Identifier } from "../../id";
export class MenuSectionItemId extends Identifier {
    constructor(id) {
        super("MenuSectionItemId", id);
    }
}
